import { doc, getDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Domain from '../../models/Domain';

async function getDomainById(domainId: string): Promise<Domain> {
  try {
    const db = firestore;
    const domainRef = doc(db, FirestoreCollections.domains, domainId);
    const domainSnapshot = await getDoc(domainRef);

    if (!domainSnapshot.exists()) {
      throw new GetDomainByIdFailure(
        `Domain with id "${domainId}" not found`,
        'not-found'
      );
    }

    return Domain.fromFirestore(domainSnapshot);
  } catch (e) {
    console.log('error: ', e);
    throw new GetDomainByIdFailure();
  }
}

export class GetDomainByIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getDomainById;
